export const LAUNCH_DARKLY_CLIENT_ID = '6011a377e9aeb709db09d46e';